import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, Button } from '@mui/material';
import ImagePicker from '../components/ImagePicker';

const API_URL = import.meta.env.VITE_API_URL;
const IMAGE_URL = import.meta.env.VITE_IMAGE_URL;

const CarouselCreate: React.FC = () => {
  const navigate = useNavigate();

  const [image, setImage] = React.useState<File | null>(null);
  const [imageUrl, setImageUrl] = React.useState<string | null>(null);
  const [mediaId, setMediaId] = React.useState<number | null>(null);

  const [imageBigger, setImageBigger] = React.useState<File | null>(null);
  const [imageBiggerUrl, setImageBiggerUrl] = React.useState<string | null>(
    null,
  );
  const [mediaBiggerId, setMediaBiggerId] = React.useState<number | null>(null);

  const [loading, setLoading] = React.useState(false);

  const handleSave = async () => {
    try {
      setLoading(true);

      const formData = new FormData();

      if (image) formData.append('image', image);
      if (mediaId) formData.append('mediaId', String(mediaId));

      if (imageBigger) formData.append('imageBigger', imageBigger);
      if (mediaBiggerId)
        formData.append('mediaBiggerId', String(mediaBiggerId));

      await axios.post(`${API_URL}/carousel`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      navigate('/carousele');
    } catch {
      alert('Помилка при створенні каталогу');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mx: 10, mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Створення каталогу
      </Typography>

      <ImagePicker
        title="Зображення каталогу"
        maxDimension={1500}
        recommendedSize={1500}
        value={imageUrl || ''}
        onChange={(value) => {
          if (value.type === 'file') {
            setImage(value.file);
            setMediaId(null);
            setImageUrl(URL.createObjectURL(value.file));
          }
          if (value.type === 'media') {
            setImage(null);
            setMediaId(value.mediaId);
            setImageUrl(value.url);
          }
        }}
      />

      <ImagePicker
        title="Зображення для більших цін"
        maxDimension={1500}
        recommendedSize={1500}
        value={imageBiggerUrl || ''}
        onChange={(value) => {
          if (value.type === 'file') {
            setImageBigger(value.file);
            setMediaBiggerId(null);
            setImageBiggerUrl(URL.createObjectURL(value.file));
          }
          if (value.type === 'media') {
            setImageBigger(null);
            setMediaBiggerId(value.mediaId);
            setImageBiggerUrl(value.url);
          }
        }}
      />

      <Button
        variant="contained"
        sx={{ mt: 3 }}
        onClick={handleSave}
        disabled={!image || loading}
      >
        Створити каталог
      </Button>
    </Box>
  );
};

export default CarouselCreate;
